import { SVGProps } from '@components/Icon/types';

export const Picture = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 3)">
      <path
        d="M13.4004 3.5C14.1734 3.50021 14.7998 4.12732 14.7998 4.90039C14.7996 5.67328 14.1733 6.29959 13.4004 6.2998C12.6273 6.2998 12.0002 5.67341 12 4.90039C12 4.12719 12.6272 3.5 13.4004 3.5Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0C18.2091 0 20 1.79086 20 4V14C20 16.14 18.3194 17.8879 16.2061 17.9951L16 18H4L3.79395 17.9951C1.7488 17.8913 0.108652 16.2512 0.00488281 14.2061L0 14V4C0 1.79086 1.79086 3.22128e-08 4 0H16ZM6.81934 7.98926C6.34509 7.63378 5.69038 7.6444 5.22754 8.01465L1.4375 11.0469C1.42602 11.0561 1.41226 11.062 1.40039 11.0703V14C1.40039 15.4359 2.56406 16.5996 4 16.5996H16C17.4359 16.5996 18.5996 15.4359 18.5996 14V10.7627L16.1289 9.21875C15.7278 8.96817 15.222 8.95488 14.8086 9.18457L12.4746 10.4814L14.4199 11.9404C14.729 12.1724 14.7915 12.6107 14.5596 12.9199C14.3276 13.2291 13.8893 13.2915 13.5801 13.0596L6.81934 7.98926ZM4 1.40039C2.56406 1.40039 1.40039 2.56406 1.40039 4V9.28223L4.35254 6.9209C5.31404 6.15173 6.67414 6.13133 7.65918 6.87012L11.2471 9.56055L14.1289 7.96094C14.9877 7.48385 16.038 7.51067 16.8711 8.03125L18.5996 9.11133V4C18.5996 2.56406 17.4359 1.40039 16 1.40039H4Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'picture';
